module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model",
    staticStyle: {
      "padding-top": "28px",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "main-title"
  }, [_vm._v("企业相册")]), _vm._v(" "), _c('div', {
    staticClass: "main-tip"
  }, [_vm._v("上传优质的视频与图片更好地向外界展示企业形象，提升招聘吸引力")]), _vm._v(" "), _c('div', {
    staticClass: "save primary-btn",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('div', {
    staticClass: "in-title flex"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("企业视频")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.videoList.length) + "/3")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left"
  }, [(_vm.videoStatus != 1 && _vm.videoList.length) ? _c('div', {
    staticClass: "video-status"
  }, [_vm._v("\n                    " + _vm._s(_vm.videoStatus == 0 ? '视频正在审核中，审核通过后求职者可见' : '视频未通过审核，请重新拍摄上传') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('video-upload', {
    attrs: {
      "video-list": _vm.videoList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('div', {
    staticClass: "in-title flex"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("外景门头")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.mainPicList.length) + "/5")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("企业的外景门头相关照片")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left img-list"
  }, [_c('image-upload', {
    attrs: {
      "img-list": _vm.mainPicList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('div', {
    staticClass: "in-title flex"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("工作环境")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.workingEnvPicList.length) + "/5")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("企业的工作环境相关照片")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left img-list"
  }, [_c('image-upload', {
    attrs: {
      "img-list": _vm.workingEnvPicList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('div', {
    staticClass: "in-title flex"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("就餐环境")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.diningEnvPicList.length) + "/5")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("企业的就餐环境相关照片")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left img-list"
  }, [_c('image-upload', {
    attrs: {
      "img-list": _vm.diningEnvPicList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('div', {
    staticClass: "in-title flex"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("住宿环境")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.accommodationEnvPicList.length) + "/5")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("企业的住宿环境相关照片")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left img-list"
  }, [_c('image-upload', {
    attrs: {
      "img-list": _vm.accommodationEnvPicList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('div', {
    staticClass: "in-title flex"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("其他照片")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.otherPicList.length) + "/5")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("企业的其他相关照片")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-left img-list"
  }, [_c('image-upload', {
    attrs: {
      "img-list": _vm.otherPicList
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e20fc932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/album/index.vue
// module id = 920
// module chunks = 1